import { FC, useCallback, RefObject } from 'react';
import { useHookstate } from '@hookstate/core';
import { JackpotModal as JackpotModalComponent } from '../../components/JackpotModal';
import { useFormatCurrency } from '../../hooks/use-format-currency';
import { useFocusChat } from '../../hooks/use-focus-chat';
import {
    meta,
    current,
    jackpotWinner,
    resetJackpotWinner,
} from '../../stores/backend';
import { chatMeta } from '../../stores/chat';
import { RoundedEmojiInputRef } from '../../components/RoundedEmojiInput';

type JackpotModalProps = {
    inputRef: RefObject<RoundedEmojiInputRef>;
};

export const JackpotModal: FC<JackpotModalProps> = ({ inputRef }) => {
    const $meta = useHookstate(meta);
    const $current = useHookstate(current);
    const $jackpotWinner = useHookstate(jackpotWinner);
    const $chatMeta = useHookstate(chatMeta);

    const formatCurrency = useFormatCurrency($current, $meta);

    const onClose = useCallback(() => {
        $meta.modals.jackpot.set(false);
        resetJackpotWinner();
    }, [$meta.modals.jackpot]);

    // Chat input is focused again so users are not interrupted if they are chatting with others while this modal opens.
    const focusChat = useFocusChat(inputRef, $chatMeta);

    const winners = $jackpotWinner.value.map((w) => {
        return {
            name: w.userAlias,
            amount: formatCurrency(w.amount),
        };
    });

    const totalJackpotAmount = formatCurrency(
        $jackpotWinner.value.reduce((total, w) => total + w.amount, 0)
    );

    return (
        <JackpotModalComponent
            isOpen={$meta.modals.jackpot.value}
            onClose={onClose}
            onAfterOpen={focusChat}
            winners={winners}
            totalJackpotAmount={totalJackpotAmount}
        />
    );
};
